<template>
  <div class='NetIcon'>
    <svg width="20px" height="20px" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" stroke-width="3" stroke="#717884" fill="none">
      <circle cx="32" cy="32" r="24.86"/>
      <path d="M32,6.84A34.09,34.09,0,0,1,43.66,32.31c0,16.19-7.28,21-11.66,24.24"/>
      <path d="M32,6.84A34.09,34.09,0,0,0,20.31,32.31c0,16.19,7.28,21,11.66,24.24"/>
      <line x1="10.37" y1="19.75" x2="53.75" y2="19.75"/>
      <line x1="32" y1="6.84" x2="32" y2="56.55"/>
      <line x1="11.05" y1="45.33" x2="52.98" y2="45.33"/>
      <line x1="7.14" y1="32.31" x2="56.86" y2="31.69"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'NetIcon'
}
</script>

<style scoped>
.NetIcon {
  cursor: pointer;
}
</style>
